var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-spotify"},[_c('iframe',{attrs:{"src":("https://open.spotify.com/embed/track/" + _vm.id),"width":"100%","height":"80","frameborder":"0","allowtransparency":"true","allow":"encrypted-media"}})])}
var staticRenderFns = []

export { render, staticRenderFns }